import React from 'react';
import { Grid, FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import ContentHeader from '../../components/ContentHeader/ContentHeader';
import PlansCard from '../../components/PlansCard/PlansCard';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import Stepper from '../../components/PaymentModalStepper/Stepper';
import axios from './../../config/axiosInstance';
import SubscriptionHistory from './SubscriptionHistory';

import { setMessage } from '../../store/actions/general';
import { verifyChat } from '../../store/actions/chat';
import { usageLog } from '../../store/actions/globalActions';

// const paymentInfo = {
//   type: 'boleto',
//   isAnnual: false,
//   boletoPath: '...',
//   title: 'Aguardando Pagamento',
//   content: 'O boleto será enviado para o email informado lucas@puntu.digital. Confira sua caixa de entrada!',
// };

function Subscription() {
  const dispatch = useDispatch();
  const [plans, setPlans] = React.useState({});
  const [planUrl, setPlanUrl] = React.useState({});
  const [pagamentoUrl, setPagamentoUrl] = React.useState({});
  const [selectedPlan, setSelectedPlan] = React.useState(null);
  const [paymentApproved, setPaymentStatus] = React.useState(false);
  const [paymentInfo, setPaymentInfo] = React.useState({});
  const [isSubscribed, setSubscribeStatus] = React.useState(false);
  const [recurringBill, setRecurringBill] = React.useState(false);
  // const [mockOpen, setMockOpen] = React.useState(true);

  const companyCode = useSelector(state => state.auth.companyCode);
  const businessName = useSelector(state => state.auth.businessName);
  const userName = useSelector(state => state.auth.userName);

  const fetchChat = React.useCallback(async () => {
    const response = await axios.get('/jivoChat/suportPlanUrl');
    verifyChat(response.data, companyCode, businessName, userName);
  }, [companyCode, businessName, userName]);

  const fetchOffers = () => axios.post('/payments/paypal/show-offers');

  const showPaymentConfirmation = (data) => {
    setPaymentInfo(data);
    setSelectedPlan(null);
    setPaymentStatus(true);
  };

  const getUrl = React.useEffect(() => {
    const url = new URL(window.location.href);
    setPlanUrl(url.searchParams.get("plan"));
    setPagamentoUrl(url.searchParams.get("Pagamento"));
  }, []);

  const refreshContent = React.useCallback(() => {
    const refreshChat = async () => {
      const response = await axios.get('/jivoChat/suportPlanUrl');
      verifyChat(response.data, companyCode, businessName, userName);
    };

    setPaymentStatus(false);
    fetchOffers()
      .then((result) => {
        refreshChat();
        setPlans(result.data);
      })
      .catch(error => dispatch(setMessage(error)));
  }, [dispatch, companyCode, businessName, userName]);

  React.useEffect(() => {
    fetchChat();
  }, [fetchChat]);

  React.useEffect(() => {
    refreshContent();
  }, [refreshContent]);

  React.useEffect(() => {
    if (plans && plans.offers) {
      const hasSubscribed = plans.offers.filter(plan => plan.isActive).length;
      setSubscribeStatus(hasSubscribed > 0);
    }
  }, [plans]);

  const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
  const userId = JSON.parse(localStorage.getItem('companies')).find(x => x.userId).userId;

  return (
    <>
      <ContentHeader
        title="Assinaturas"
        subtitle="Escolha o melhor plano para sua empresa"
      />

      <Grid container spacing={3} justify="center">
        {
          (plans && plans.offers) && plans.offers.map(plan => (
            <Grid item md={6} style={{ maxWidth: '400px' }}>
              <PlansCard
                id={plan.id}
                description={plan.benefits.split('\\n')}
                monthlyPrice={plan.monthlyPrice}
                totalPrice={plan.totalPrice}
                title={plan.description}
                onClick={() => { setSelectedPlan(plan); usageLog("Assinaturas/comprar/premium", companyId, userId); }}
                active={plan.isActive}
                category={plan.category}
                expiresIn={plan.expiresIn}
                isSubscribed={isSubscribed}
                observations={plan.observations}
                isTrial={plan.isTrial}
                yearlyPriceInstallments={plan.yearlyPriceInstallments}
              />
            </Grid>
          ))
        }
      </Grid>

      <SubscriptionHistory payments={plans.payments || []} />

      {selectedPlan && (
        <Stepper
          plan={selectedPlan}
          onClose={() => setSelectedPlan(null)}
          onConfirmPayment={data => showPaymentConfirmation(data)}
        />
      )}

      <ConfirmDialog
        // title={paymentInfo.title}
        open={paymentApproved && !selectedPlan}
        // open={mockOpen}
        content={(
          <>
            {paymentInfo.content}
            {
              paymentInfo.type === 'boleto' && (
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={recurringBill}
                        onChange={() => setRecurringBill(!recurringBill)}
                        name="pagamentoRecorrente"
                        color="primary"
                      />
                    }
                    label={(
                      <Typography variant="body2">
                        {`Gostaria de receber o boleto automaticamente neste email ${paymentInfo.isAnnual ? 'anualmente' : 'mensalmente'}*`}
                      </Typography>
                    )}
                  />
                  <Typography variant="caption">
                    *Esta opção não gera nenhuma cobrança ou dívida.
                  </Typography>
                </div>
              )
            }
          </>
        )}
        confirmText={paymentInfo.type === 'boleto' ? 'Ver boleto' : 'Fechar'}
        onConfirm={() => {
          if (paymentInfo.type === 'boleto') {
            window.open(paymentInfo.boletoPath, '_blank');
          } else {
            refreshContent();
          }
        }}
        hideClose={paymentInfo.type !== 'boleto'}
        onClose={() => {
          if (paymentInfo.type === 'boleto') {
            refreshContent();
            if (recurringBill) {
              const { paymentId, invoiceId } = paymentInfo;
              axios.post('/payments/paypal/create-payment-contract', { paymentId, invoiceId });
            }
            // setMockOpen(false);
          }
        }}
        closeText={paymentInfo.type === 'boleto' ? 'Fechar' : 'Cancelar'}
      />
    </>
  );
}

export default Subscription;
